import { Job, SupabaseJob } from '@applicator/shared'

import { loadRelevanceSettings } from '../../lib/relevanceSettings'

import { createDateHandlers } from './handlers.dates'
import { createRelevanceHandlers } from './handlers.relevance'
import { createStatusHandlers } from './handlers.status'
import { UserRules } from './types'

interface HandlersParams {
  jobs: Job[]
  supabaseJobs: SupabaseJob[]
  setJobs: React.Dispatch<React.SetStateAction<Job[]>>
  setSupabaseJobs: React.Dispatch<React.SetStateAction<SupabaseJob[]>>
  setError: React.Dispatch<React.SetStateAction<string | null>>
  setAnalyzingJobIds: React.Dispatch<React.SetStateAction<Set<string>>>
  analyzingJobIds: Set<string>
  relevanceSettings: Awaited<ReturnType<typeof loadRelevanceSettings>> | null
  setRelevanceSettings: React.Dispatch<React.SetStateAction<Awaited<ReturnType<typeof loadRelevanceSettings>> | null>>
  userRules: UserRules
  loadJobs: () => Promise<void>
}

export const createHandlers = ({
  jobs,
  supabaseJobs,
  setJobs,
  setSupabaseJobs,
  setError,
  setAnalyzingJobIds,
  analyzingJobIds,
  relevanceSettings,
  setRelevanceSettings,
  userRules,
  _loadJobs,
}: HandlersParams) => {
  const statusHandlers = createStatusHandlers({
    jobs,
    setJobs,
    setError,
  })

  const relevanceHandlers = createRelevanceHandlers({
    supabaseJobs,
    setSupabaseJobs,
    setAnalyzingJobIds,
    analyzingJobIds,
    relevanceSettings,
    setRelevanceSettings,
  })

  const dateHandlers = createDateHandlers({
    jobs,
    supabaseJobs,
    setJobs,
    setSupabaseJobs,
    setError,
    userRules,
  })

  return {
    handleStatusChange: statusHandlers.handleStatusChange,
    handleAnalyzeRelevance: relevanceHandlers.handleAnalyzeRelevance,
    handleDeleteJob: statusHandlers.handleDeleteJob,
    handleDateChange: dateHandlers.handleDateChange,
    handleQuickAction: dateHandlers.handleQuickAction,
    handleExcitementChange: statusHandlers.handleExcitementChange,
  }
}
